import styled from 'styled-components';
export default styled.span.withConfig({
  displayName: "ErrorLabel",
  componentId: "sa01ka-0"
})(["", ""], ({
  theme: _theme
}) => {
  // theme typed as any
  const theme = _theme;
  return `color: ${theme.color['fill-alert-default']};
      font-weight: ${theme.typography['heading-50'].fontWeight};
    `;
});